import * as React from 'react';
import type { SVGProps } from 'react';
const SvgKeyboardCapslock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#keyboard-capslock_svg__a)">
      <path
        fill="#263E6A"
        d="M12 8.41 16.59 13 18 11.59l-6-6-6 6L7.41 13zM6 18h12v-2H6z"
      />
    </g>
    <defs>
      <clipPath id="keyboard-capslock_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgKeyboardCapslock;
